import axios from "axios";

const MEDIA_ITEM_REST_URL = "/web/rest/media-item";
const BASE_URL = "/api/risk-management/risk-location";
const LOCATION_SELECT_ENDPOINT = '/web/rest-risk-management/select-location/self-service';

export function getRiskLocations() {
  return axios.get(BASE_URL);
}

/**
 * Retrieve media item based on given array of tags.
 */
export function getMediaItem(...tags) {
  return axios.post(MEDIA_ITEM_REST_URL, {
    tags: tags,
    presentation: "bvmop clean display on",
    hideTitle: true
  });
}

/**
 * Select location and redirect to page based on existence of a scan.
 * Note: Redirect is done in the rest endpoint
 */
export function selectLocation(locationHash) {
  location.assign(`${LOCATION_SELECT_ENDPOINT}?locationHash=${encodeURI(locationHash)}`);
}